// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
export const getPromiseWithResolvers = () => {
    let resolve;
    let reject;
    const promise = new Promise((resolveFn, rejectFn) => {
        resolve = resolveFn;
        reject = rejectFn;
    });
    return { promise, resolve, reject };
};
//# sourceMappingURL=getPromiseWithResolvers.js.map